import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Button, FormControl } from "react-bootstrap";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { faThumbsUp, faEdit, faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { EyeOutlined, FileTextOutlined } from "@ant-design/icons";

import { Tabla } from "../../../components/Table/Table";
import ConveniosFilter from "../../../components/Filter/ConveniosFilter";
import EditConvenio from "./Components/EditConvenio";
import ModalTable from "./Components/ModalTable";
import { v4 as uuidv4 } from "uuid";
import { getConvCaracters, getConvenios, getConvEstado, getConvFormaPagos } from "../../../redux/Sections/Convenios/actions";
import NewConvenio from "./Components/NewConvenio";
// import icon from "../../../assets/static/images/secciones/convenios.png";
import { getAbogados } from "../../../redux/Sections/Abogados/actions";
import { convenioService } from "../../../_services/convenios.service";
import Swal from "sweetalert2";
import { setLoading } from "../../../redux/Loading/actions";
import DescargarExcel from "../../../components/DescargarExcel/DescargarExcel";
import { useUser } from "../../../hooks/useUser";
import TooltipText from "../../../components/TooltipText";
// import jsPDF from "jspdf";
import "./Convenios.css";
// import { calcularMontoArray, formatCapital } from "../../../utils/utils";
// import moment from "moment";
// import Pako from "pako";
// import { actuacionesService } from "../../../_services/actuaciones.service";
import { generarDescargarPDFConvenio } from "./utils/convenioGenDownload";
// import Pako from "pako";


const Convenios = ({ dataList, getConvCaracters, getConvFormaPagos, getConvenios, setLoading, tiposRetiro, abogados }) => {
  const user = useUser();

  const [showFilter, setShowFilter] = useState(true);
  const [show, setShow] = useState(false);
  const [showCovenio, setShowConvenio] = useState(false);
  const [convenioId, setConvenioId] = useState(false);
  const [newConvenio, setNewConvenio] = useState(false);
  const [filters, setFilters] = useState({});
  const [showTable, setShowTable] = useState(false);

  useEffect(() => {
    getConvCaracters();
  }, []);

  useEffect(() => {
    getConvFormaPagos();
  }, []);

  const handleOpen = () => setShow(true);
  const handleClose = () => setShow(false);


  const handleShowClose = () => setShowConvenio(false);
  const handleShowOpen = (id) => {
    setConvenioId(id);
    setShowConvenio(true);
  };

  const handleEdit = (data) => {
    setConvenioId(data);
    handleOpen();
  };

  const handleConfirm = async (id) => {
    try {
      if (id) {
        Swal.fire({
          title: "¿Esta seguro de confirmar este convenio?",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "No",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirmar",
          reverseButtons: true,
        }).then(async (result) => {
          if (result.isConfirmed) {
            setLoading(true);
            let response = await convenioService.comprobarConvenio({ id });

            if (response && response[0].estado === 0) {
              getConvenios(filters);
              setLoading(false);
              return Swal.fire(
                "Exito!",
                "Se confirmó correctamente.",
                "success"
              );
            }
            else {
              setLoading(false);
              return Swal.fire(
                "Error!",
                "Ocurrio un error, intentelo nuevamente.",
                "error"
              );
            }
          }
        });
      }

    }
    catch (err) {
      console.log(err);
      return Swal.fire(
        "Error!",
        "Ocurrio un error, intentelo nuevamente.",
        "error"
      );
    }
  };

  const generatePDF = async (data) => {
    try {
      // const convenio = await convenioService.getConvenioById(data.convenio);
      // const imponibles = convenio?.convenio_convpp.map(({ imponible, recurso }) => {
      //   return {
      //     abogado: convenio?.convenio_abogado?.codexterno,
      //     imponible,
      //     recurso
      //   }
      // })
      // const causa = Pako.gzip(JSON.stringify(imponibles));
      // const radicacionResponse = await actuacionesService.getRadicacion({data: causa, fecha: convenio.fechacarga});
      // const radicacion = radicacionResponse.length ? radicacionResponse[0].estapas[0].etp01 : null;
      await generarDescargarPDFConvenio(data.convenio);
    }
    catch (err) {
      console.log("generatePDF error ", err);
      return err;
    }
  };


  const handleDelete = async (convenio) => {
    try {
      if (convenio) {
        Swal.fire({
          title: "¿Esta seguro de eliminar este convenio?",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "No",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirmar",
          reverseButtons: true,
        }).then(async (result) => {
          if (result.isConfirmed) {
            setLoading(true);
            let response = await convenioService.deleteConvenio({ convenio });

            if (response && response[0].estado === 0) {
              getConvenios(filters);
              setLoading(false);

              return Swal.fire(
                "Exito!",
                "Se eliminó correctamente.",
                "success"
              );
            }
            else {
              setLoading(false);
              return Swal.fire(
                "Error!",
                "Ocurrio un error, intentelo nuevamente.",
                "error"
              );
            }
          }
        });
      }

    }
    catch (err) {
      console.log(err);
      return Swal.fire(
        "Error!",
        "Ocurrio un error, intentelo nuevamente.",
        "error"
      );
    }
  };

  const handleModRetiro = async (row, plan, in_estado) => {
    try {
      if (row) {
        Swal.fire({
          title: "¿Esta seguro de modificar este plan?",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "No",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirmar",
          reverseButtons: true,
        }).then(async (result) => {
          if (result.isConfirmed) {
            setLoading(true);
            let response = await convenioService.modRetiro({
              in_convenio: row?.convenio,
              in_nrodni: user?.id,
              in_recurso: plan?.recurso,
              in_imponible: plan?.imponible,
              in_estado,
            });

            if (response && response[0].estado === 0) {
              getConvenios(filters);
              setLoading(false);

              return Swal.fire(
                "Exito!",
                "Se modifico correctamente.",
                "success"
              );
            }
            else {
              setLoading(false);
              return Swal.fire(
                "Error!",
                "Ocurrio un error, intentelo nuevamente.",
                "error"
              );
            }
          }
        });
      }
    }
    catch (err) {
      console.log(err);
      return Swal.fire(
        "Error!",
        "Ocurrio un error, intentelo nuevamente.",
        "error"
      );
    }
  };

  const columns = [
    {
      title: "FECHA",
      dataIndex: "format_confirma",
      key: "format_confirma",
    },
    {
      title: "NRO DE CONVENIO",
      dataIndex: "convenio",
      key: "convenio",
    },
    {
      title: "ABOGADO",
      dataIndex: "codexterno",
      key: "codexterno",
    },
    {
      title: "FIRMANTE",
      dataIndex: "frm_nombre",
      key: "frm_nombre",
    },
    {
      title: "PLANES",
      render: (_, row) => {
        return (
          <div key={"planes" + row.uuid}>
            {row?.planes ? (
              <table>
                <thead>
                  <tr style={{ fontSize: 14 }}>
                    <th className="p-1">Imponible</th>
                    <th className="p-1">Recurso</th>
                    <th className="p-1">Identificación según rafam</th>
                    <th className="p-1">Estado</th>
                  </tr>
                </thead>
                <tbody>
                  {JSON.parse(row.planes).map((p, i) => {
                    let retiro = tiposRetiro.find((r) => r.nombre === p.estado_retiro);

                    return (
                      <tr style={{ fontSize: 14 }} key={"plan" + row.uuid + i}>
                        <td style={{ minWidth: 120 }}>{p.imponible}</td>
                        <td style={{ minWidth: 100 }}>{p.recurso}</td>
                        <td style={{ minWidth: 100 }}>{p.plan}</td>
                        <td style={{ minWidth: 140 }}>
                          {("A00" === user?.abogado || row?.codexterno === user?.abogado) ? (
                            <TooltipText placement="top" text="Cambiar estado del plan de pago" >
                              <FormControl
                                as="select"
                                onChange={(e) => handleModRetiro(row, p, e.target.value)}
                                value={retiro?.id || ""}
                                style={{
                                  fontSize: 14,
                                  padding: 4,
                                  height: 40,
                                  margin: 5
                                }}
                              >
                                {tiposRetiro.map((e) => {
                                  return (
                                    <option value={e.id} key={e.id}>{e.nombre}</option>
                                  );
                                })}
                              </FormControl>
                            </TooltipText>
                          ) : <span>{retiro.nombre}</span>}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : null}
          </div>
        );
      }
    },
    {
      title: "ACCIÓN",
      dataIndex: "accion",
      render: (_, row) => (
        <div className="d-flex justify-content-around align-items-center">
          <TooltipText placement="top" text="Ver datos del convenio" >
            <EyeOutlined onClick={() => handleShowOpen(row.convenio)} className="convenio-icon mx-1" />
          </TooltipText>

          {("A00" === user?.abogado || row?.codexterno === user?.abogado) && !row?.fc_confirma ? (
            <>
              <TooltipText placement="top" text="Confirmar convenio" >
                <FontAwesomeIcon className="icon-pointer mx-1" title="Confirmar Convenio" icon={faThumbsUp} size="lg" onClick={() => handleConfirm(row.convenio)} />
              </TooltipText>
              <TooltipText placement="top" text="Editar Convenio" >
                <FontAwesomeIcon className="icon-pointer mx-1" title="Editar Convenio" onClick={() => handleEdit(row.convenio)} icon={faEdit} size="lg" />
              </TooltipText>
              <TooltipText placement="top" text="Eliminar Convenio" >
                <FontAwesomeIcon className="icon-pointer mx-1" title="Eliminar Convenio" onClick={() => handleDelete(row.convenio)} icon={faTrashAlt} size="lg" />
              </TooltipText>
            </>
          ) : null}


          {row?.fc_confirma ? (
            <TooltipText placement="top" text="Ver PDF del convenio" >
              {/* <a
                href={`https://wsrfa.sannicolasciudad.gob.ar/cobrojud/convPdf.php?id=${row.convenio}`}
                target="_blank"
                rel="noreferrer"
                style={{ color: "#687073" }}
              > */}
              <FileTextOutlined className="convenio-icon mx-1" onClick={() => generatePDF(row)} />
              {/* </a> */}
            </TooltipText>
          ) : null}
        </div>
      )
    }
  ];


  const formatData = (data) => {
    try {
      return data.map(e => {
        return {
          ...e,
          uuid: uuidv4(),
        };
      });
    }
    catch (err) {
      console.log("err", err);
      return [];
    }
  };

  const handleNewConvenio = () => {
    setNewConvenio(!newConvenio);
  };


  function exportData(list) {
    let filename = "convenios.xlsx";

    const dataList = list.map((e) => {
      return {
        "NRO DE CONVENIO": e.id,
        "ABOGADO": e.codexterno,
        "FIRMANTE": e.frm_nombre,
        "FECHA": e.format_confirma
      };
    });

    let name = "Convenios";

    return {
      dataList,
      filename,
      name
    };
  }

  return (
    <div className="mt-4">
      {/* <div className="section-title d-flex align-items-center">
        <img src={icon} alt="gestion-legal" />
        <span>Convenios</span>
      </div> */}

      {
        newConvenio ?
          (
            <div className="new-convenio">
              <NewConvenio handleNewConvenio={handleNewConvenio} filters={filters} abogados={abogados} />
            </div>
          ) :
          (
            <>
              <div className="w-100 d-flex justify-content-end pr-5">
                <Button className="custom-button" style={{ maxWidth: 160 }} onClick={handleNewConvenio}>Nuevo Convenio</Button>
              </div>
              <div className="buttons-filter">
                <h3 className="mr-3">Filtros:</h3>
                <div className="button-filter">
                  {showFilter ?
                    <Button
                      variant="danger"
                      onClick={() => setShowFilter(false)}
                      className="danger-button d-flex align-items-center"
                      style={{ maxWidth: 105 }}
                    >
                      <FontAwesomeIcon icon={faArrowDown} size="1x" /><span className="ml-2">Ocultar</span>
                    </Button>
                    : <Button
                      onClick={() => setShowFilter(true)}
                      className="custom-button d-flex align-items-center"
                      style={{ maxWidth: 105 }}
                    ><FontAwesomeIcon icon={faArrowUp} size="1x" /><span className="ml-2">Mostrar</span>
                    </Button>}
                </div>
              </div>
              <div className="section-filter">
                <ConveniosFilter showFilter={showFilter} setShowFilter={setShowFilter} style={{ marginBottom: "30px" }} action={getConvenios} setFilters={setFilters} setShowTable={setShowTable} />
              </div>
              {showTable ? (
                <div className="section-table">
                  <Tabla dataList={formatData(dataList)} columns={columns} />
                  <div className="mt-3">
                    <div style={{ maxWidth: 170 }}>
                      <DescargarExcel data={exportData(dataList)} />
                    </div>
                  </div>
                </div>
              ) : null}
            </>
          )
      }

      {show ? <EditConvenio show={show} handleClose={handleClose} convenioId={convenioId} filters={filters} abogados={abogados} /> : null}
      {showCovenio ? <ModalTable show={showCovenio} handleClose={handleShowClose} convenioId={convenioId} /> : ""}
    </div>
  );
};


const mapStateToProps = (state) => {
  return {
    dataList: state.dashboard.convenios,
    tiposRetiro: state.dashboard.tiposRetiro,
    abogados: state.dashboard.abogadosList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getConvCaracters: () => dispatch(getConvCaracters()),
    getConvEstado: () => dispatch(getConvEstado()),
    getConvFormaPagos: () => dispatch(getConvFormaPagos()),
    getConvenios: (data) => dispatch(getConvenios(data)),
    setLoading: (data) => dispatch(setLoading(data)),
    getAbogados: () => dispatch(getAbogados()),
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(Convenios);